export default __webpack_public_path__ + "e3a9dae.png";